export const ACCOUNT = '/account'
export const ACCOUNT_CREATE = '/account/create'
export const ACCOUNT_EDIT = '/account/:id/edit'
export const MEDIA_AGENCY = '/media-agency'
export const MEDIA_AGENCY_CREATE = '/media-agency/create'
export const MEDIA_AGENCY_EDIT = '/media-agency/:id/edit'
export const SSP = '/ssp'
export const SSP_CREATE = '/ssp/create'
export const SSP_EDIT = '/ssp/:id/edit'
export const ADVERTISER = '/advertiser'
export const ADVERTISER_CREATE = '/advertiser/create'
export const ADVERTISER_EDIT = '/advertiser/:id/edit'
export const CAMPAIGN = '/campaign'
export const CAMPAIGN_CREATE = '/campaign/create'
export const CAMPAIGN_COPY = '/campaign/:id/copy'
export const CAMPAIGN_EDIT = '/campaign/:id/edit'
export const AD_GROUP = '/ad-group'
export const AD_GROUP_CREATE = '/ad-group/create'
export const AD_GROUP_EDIT = '/ad-group/:id/edit'
export const CREATIVE = '/creative'
export const CREATIVE_CREATE = '/creative/create'
export const CREATIVE_EDIT = '/creative/:id/edit'
export const CREATIVE_BULK = '/creative/bulk'
export const AD_SIZE = '/ad-size'
export const AD_SIZE_CREATE = '/ad-size/create'
export const AD_SIZE_EDIT = '/ad-size/:id/edit'
export const FILTER_LIST = '/filter-list'
export const FILTER_LIST_CREATE = '/filter-list/create'
export const FILTER_LIST_EDIT = '/filter-list/:id/edit'
export const RETARGETING_LIST = '/retargeting-list'
export const RETARGETING_LIST_CREATE = '/retargeting-list/create'
export const RETARGETING_LIST_EDIT = '/retargeting-list/:id/edit'
export const FRAUD_DOMAIN = '/fraud-domain'
export const CONTEXTUAL_TARGETING = '/contextual-targeting'
export const TEST_REQUEST = '/test-request'
export const REPORT_BUILDER = '/report-builder'
export const REPORT_COPY = '/report/:id/copy'
export const REPORT_EDIT = '/report/:id/edit'
export const REPORT = '/report/:id/edit/load'
export const SAVED_REPORT = '/report'
export const TRACKER_REPORT = '/tracker-report'
export const NOTIFICATION_SETTING = '/notification-setting'
export const NOTIFICATION_SETTING_EDIT = '/notification-setting/:id/edit'
export const TRACKER = '/tracker'
export const TRACKER_CREATE = '/tracker/create'
export const TRACKER_EDIT = '/tracker/:id/edit'
export const LOG = '/log'
export const DASHBOARD = '/dashboard'



// WEBPACK FOOTER //
// ./src/constants/routes.ts